import { useMutation, useQueryClient } from 'react-query'
import { format } from 'date-fns'

import { useAuthedFetch } from '../auth/useAuthedFetch'
import withFetchCancel from '../libs/withFetchCancel'

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_ENDPOINT

export const useShippingSendMutation = options => {
  const authedFetch = useAuthedFetch()

  return useMutation(
    data =>
      withFetchCancel(signal =>
        authedFetch('POST', `${BACKEND_ENDPOINT}/shippings`, {
          signal,
          data,
          parseJSON: true,
        }),
      ),
    options,
  )
}

export const useShippingUpdateMutation = () => {
  const authedFetch = useAuthedFetch()

  return useMutation(data => {
    const getPickupBody = () => ({
      has_pickup_asap: false,
      date: format(new Date(data.minTime), 'yyyy-MM-dd'),
      time: [
        {
          min_hourminute: format(new Date(data.minTime), 'HH:mm'),
          max_hourminute: format(new Date(data.maxTime), 'HH:mm'),
        },
      ],
    })

    return withFetchCancel(signal =>
      authedFetch('POST', `${BACKEND_ENDPOINT}/manifest/v2.0/pickups`, {
        signal,
        data: {
          shipping_codes: data.shippingCodes,
          pickup: data.hasPickupAsap
            ? { has_pickup_asap: true }
            : getPickupBody(),
        },
        parseJSON: true,
      }),
    )
  })
}

export const useInvalidateShippingsTracking = () => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries('shippingsTracking')
}
